import { z } from 'zod';
export const aiToolExecuteSchema = z.object({
    tool: z.string().min(1).max(200),
    params: z.record(z.unknown()).optional().default({}),
});
export const aiAgentCreateSchema = z.object({
    name: z.string().min(1).max(100),
    description: z.string().max(500).optional(),
    apiKey: z.string().min(32).max(255),
    permissions: z.array(z.string()).optional(),
});
export const aiEventsQuerySchema = z.object({
    format: z.enum(['json', 'sse']).optional().default('json'),
    limit: z.coerce.number().int().min(1).max(500).optional().default(50),
    type: z.string().optional(),
});
export const aiSchemaQuerySchema = z.object({
    table: z.string().optional(),
    detailed: z.coerce.boolean().optional().default(false),
});
// --- Faz 2: Operational Memory ---
export const aiMemorySetSchema = z.object({
    value: z.string().min(1),
    category: z.string().min(1).max(50),
    summary: z.string().max(500).optional(),
    tags: z.string().max(500).optional(),
    priority: z.number().int().min(1).max(10).optional(),
    expiresInHours: z.number().positive().optional(),
});
// --- Conversations ---
export const aiConversationCreateSchema = z.object({
    title: z.string().max(255).optional(),
    context: z.record(z.unknown()).optional(),
});
export const aiMessageCreateSchema = z.object({
    role: z.enum(['user', 'assistant', 'system', 'tool']),
    content: z.string().optional(),
    toolCalls: z.array(z.object({
        tool: z.string(),
        params: z.unknown(),
        result: z.unknown(),
    })).optional(),
    toolName: z.string().max(200).optional(),
    tokensUsed: z.number().int().min(0).optional(),
});
// --- Tasks ---
export const aiTaskCreateSchema = z.object({
    type: z.string().min(1).max(100),
    description: z.string().min(1),
    params: z.record(z.unknown()).optional(),
    scheduledAt: z.string().datetime().optional(),
});
export const aiTaskStatusUpdateSchema = z.object({
    status: z.enum(['running', 'completed', 'failed', 'cancelled']),
    result: z.unknown().optional(),
    errorMessage: z.string().optional(),
});
//# sourceMappingURL=ai.schema.js.map